import React from 'react';
import '../styles/dashboard.css'; // or your report-specific CSS

const CreateReportPage = () => {
  return (
    <div key={Date.now()} className="main_content fade-in">
      <h2 className="create-title">📝 Create New Report</h2>
      <p>This is where your report creation form will go.</p>
    </div>
  );
};

export default CreateReportPage;
